import { MenuItem, Select } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Language_Lists } from "../../../api/api";
import arrow from "../../../assets/images/dropdown-arrow.svg";
import "./Langselect.scss";

const LanguageDropdown = ({ setName, names, onlyview, setId }) => {
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(names);

  useEffect(() => {
    if (names) {
      const selectedLanguageName = languages.find(
        (lang) => lang.name === names
      );
      setSelectedLanguage(selectedLanguageName);
    }
  }, [names, languages]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const Language = await Language_Lists();
        if (Language?.status === true && Language.data != []) {
          setLanguages(Language.data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchLanguages();
  }, []);

  const handleLanguageChange = (e) => {
    const selectedLanguageCode = e.target.value;
    const selectedLanguageName = languages.find(
      (lang) => lang.code === selectedLanguageCode
    );

    if (selectedLanguageName) {
      setSelectedLanguage(selectedLanguageName);
      setId(selectedLanguageCode); // Assuming setId takes the code
      setName(selectedLanguageName.name);
    }
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    disablePortal: false,
    keepMounted: true,
    getContentAnchorEl: null, // ✅ required in v4
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 410,
        backgroundColor: "#2E2E2E",
        color: "#D9D9D9",
        borderRadius: "6px",
        scrollbarGutter: "stable",
        marginTop: "10px",
      },
    },
    MenuListProps: {
      style: { padding: 0 },
    },
  };

  const ArrowIcon = () => (
    <img
      src={arrow}
      alt="dropdown arrow"
      style={{ width: 16, height: 16, marginRight: 10 }}
    />
  );

  return (
    <Select
      readOnly={onlyview}
      value={selectedLanguage ? selectedLanguage.code : ""}
      onChange={handleLanguageChange}
      className={`${
        onlyview ? "disable" : ""
      } custom-dropdown language-dropdown`}
      MenuProps={MenuProps}
      displayEmpty
      IconComponent={ArrowIcon}
    >
      <MenuItem value="" disabled>
        <span style={{ color: "#a9a9a9", fontSize: 14, cursor: "pointer" }}>
          Select a Language
        </span>
      </MenuItem>
      {languages.map((lang, index) => (
        <MenuItem key={`${lang.code}-${index}`} value={lang.code}>
          {lang.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageDropdown;
